export default "__VITE_ASSET__20ec7c44__"